import graphql__d1ab61b770fec947b46d from "./__generated__/AnswerMatrix_answer.graphql.js";import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import MatrixField from "../Form/Field/MatrixField";

const AnswerMatrix = props => {
  const { itemOptions, other, otherValue, formField } = useFragment(
    AnswerMatrix_answer,
    props.answer
  );

  const {
    fieldName,
    label,
    required,
    hint,
    hintPosition,
    options,
    items,
    hide,
    maximumSelectableOptions,
    singleOptionSelection,
    displayOtherField,
    otherFieldLabel
  } = formField;

  const { parent } = props;

  const values = useMemo(
    () =>
      itemOptions.map(itemOption => {
        const { id: itemId } = itemOption.item;
        const { id: optionId } = itemOption.option;

        return { itemId, optionId };
      }),
    [itemOptions]
  );

  return (
    <MatrixField
      fieldName={fieldName}
      label={label}
      required={required}
      hint={hint}
      hintPosition={hintPosition}
      items={items}
      options={options}
      maximumSelectableOptions={maximumSelectableOptions}
      singleOptionSelection={singleOptionSelection}
      displayOtherField={displayOtherField}
      otherFieldLabel={otherFieldLabel}
      hide={hide}
      parent={parent}
      defaultValues={values}
      defaultOther={other}
      defaultOtherValue={otherValue}
    />
  );
};

const AnswerMatrix_answer = graphql__d1ab61b770fec947b46d;

export default AnswerMatrix;
